import { request } from './request';

export type FeatureName =
  | 'annual-returns'
  | 'internal-mailbox'
  | 'office-post-emails'
  | 'two-factor-authentication'
  | 'help-centre';

export type FeatureScopes = number[] | ['*'];

export function isWildcard(scope: FeatureScopes): scope is ['*'] {
  return scope[0] === '*';
}

export type FeatureFlag = {
  units: FeatureScopes;
  regions: FeatureScopes;
};

export type FeatureFlags = Partial<Record<FeatureName, FeatureFlag>>;

export const fetchFeatureFlags = () =>
  request<FeatureFlags>({
    url: '/api/v1/feature-flags',
    method: 'GET',
  });
